<template>
<div class="chapter">
<div class="inner_page">
<p class="dedt"><a id="page_ii"></a>FOR OTTO PENZLER</p>
<p class="ded">Though we talk of all Time smothers,</p>
<p class="ded">And all that Age affrights,</p>
<p class="ded">Yet with joy in one another,</p>
<p class="ded">Laugh through these New York nights.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?6a60421d